import { type FC } from "react";
import { Table, Tr, Th, Td } from "@root/shared/components/Table";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { Button } from "@root/shared/components/Button";
import { Link } from "@root/shared/components/Link";
import * as styles from "./styles.css";

type Props = {
  content: string;
  contentName: string;
  name: string;
  handleClickMessageButton: () => void;
  isSP: boolean;
  isShowTelLink: boolean;
};

export const ModalContents: FC<Props> = ({
  content,
  contentName,
  name,
  isSP,
  isShowTelLink,
  handleClickMessageButton,
}) => {
  return (
    <>
      <Table>
        <Tr>
          <Th width="165px">応募者</Th>
          <Td className={styles.td}>{name}</Td>
        </Tr>
        <Tr>
          <Th width="165px">{contentName}</Th>
          <Td className={styles.td}>{content}</Td>
        </Tr>
      </Table>
      {isShowTelLink && (
        <div className={styles.linkContainer}>
          <Link theme="primary" href={`tel:${content}`} className={styles.link} size="large">
            通話アプリで発信する
          </Link>
        </div>
      )}
      {/* TODO: GuidanceBoxコンポーネントが実装され次第置き換える */}
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <b>メッセージでも、応募者とやり取りができます。</b>
          <p className={styles.boxText}>
            メッセージを使った場合：採用率 <span className={styles.emphasizeText}>2倍</span>
          </p>
          <div className={styles.linkContainer}>
            <Button
              theme="tertiary"
              onClick={handleClickMessageButton}
              className={styles.link}
              size={isSP ? "large" : "small"}
            >
              メッセージを使ってみる
            </Button>
          </div>
        </div>
        <div className={styles.imageContainer}>
          <LazyLoadImage
            src="/images/user_frontend/sp/img_reward_request_confirmation.png"
            alt=""
            width={123}
            height={90}
          />
        </div>
      </div>
    </>
  );
};
